import { ListGameMobile } from '../../../component/ListGameMobile'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../component/MaHoaDuLieu'
import { getApiUrl } from '../../../api/api'
import Loading from '../../../component/Loading/Loading'
import { useState } from 'react'
import { DangKyDangNhapMobile } from '../../DangKyDangNhapMobile'

function Hot () {
  const [isloading, setisLoading] = useState(false)
  const device = window.innerWidth > 540 ? 'd' : 'm'
  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))
  const [tab, settab] = useState('')
  const [isOpen, setisOpen] = useState(false)
  const dangnhap = localStorage.getItem('dangnhap')

  const data = [
    {
      logo: '/mobile/thethao/logosaba.png',
      img: '/mobile/thethao/anhsaba.webp',
      background: '/backgroundtt.png',
      portfolio: 'ThirdPartySportsBook',
      gameproviderid: '44',
      gameid: '0'
    },
    {
      logo: '/mobile/thethao/logobti.png',
      img: '/mobile/thethao/anhbti.webp',
      background: '/backgroundtt.png',
      portfolio: 'ThirdPartySportsBook',
      gameproviderid: '1022',
      gameid: '0'
    },
    {
      logo: '/mobile/daga/logws.png',
      img: '/mobile/daga/anhws.webp',
      background: '/mobile/daga/backdaga.png',
      portfolio: 'ThirdPartySportsBook',
      gameproviderid: '1070',
      gameid: '0'
    },
    {
      logo: '/mobile/casino/logodg.png',
      img: '/mobile/casino/anhdg.webp',
      background: '/mobile/casino/backcasino.png',
      portfolio: 'SeamlessGame',
      gameproviderid: '1030',
      gameid: '0'
    },
    {
      logo: '/mobile/casino/logosexy.png',
      img: '/mobile/casino/anhsexy.webp',
      background: '/mobile/casino/backcasino.png',
      portfolio: 'SeamlessGame',
      gameproviderid: '7',
      gameid: '0'
    },
    {
      logo: '/mobile/casino/logowm.png',
      img: '/mobile/casino/anhwm.webp',
      background: '/mobile/casino/backcasino.png',
      portfolio: 'SeamlessGame',
      gameproviderid: '0',
      gameid: '0'
    }
  ]

  const hanldePostWidthdraw = async (portfolio, gameProviderId, gameId) => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio,
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()
      console.log(data)

      if (data.message) {
        setisLoading(false)
        alert(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setisLoading(false)
        }
      }
    } catch (error) {
      setisLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }
  return (
    <>
      <Loading isLoading={isloading} />
      <ListGameMobile>
        <ul className='ulthethao'>
          {data.map((item, index) => (
            <li
              className='thethao_item'
              style={{ background: `url(${item.background})` }}
              key={index}
              onClick={() => {
                if (!dangnhap) {
                  setisOpen(true)
                  settab('Đăng nhập')
                } else
                  hanldePostWidthdraw(
                    item.portfolio,
                    item.gameproviderid,
                    item.gameid
                  )
              }}
            >
              <div className='gameitem'>
                <div className='firm_logo'>
                  <i>
                    <img src={item.logo} alt='' />
                  </i>
                </div>
                <div
                  style={{ backgroundImage: `url(${item.img})` }}
                  className='anhgame'
                ></div>
                <div className='gametag'></div>
              </div>
            </li>
          ))}
        </ul>
      </ListGameMobile>
      <DangKyDangNhapMobile
        tab={tab}
        settab={settab}
        isOpen={isOpen}
        onClose={() => setisOpen(false)}
      />
    </>
  )
}

export default Hot
